import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[hsl(var(--bg))]/85 border-b border-[hsl(var(--line))]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-edge flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[hsl(var(--ink))] text-[hsl(var(--ink))] font-display text-base tracking-tight">
            EG
          </span>
          <span className="font-display text-lg md:text-xl text-[hsl(var(--ink))] tracking-tight">
            EG Spanish Interpreting
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[hsl(var(--text-muted))] hover:text-[hsl(var(--accent))] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#contact" data-testid="nav-cta-quote" className="btn-primary !py-3 !px-6">
            Request a Quote
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden inline-flex items-center justify-center w-10 h-10 text-[hsl(var(--ink))]"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[hsl(var(--line))] bg-[hsl(var(--bg))]">
          <div className="container-edge py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-base font-medium text-[hsl(var(--ink))] hover:text-[hsl(var(--accent))]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="btn-primary self-start"
            >
              Request a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
